export const lightGray = "#e6e6e6"
export const darkBlue = '#192d94';
